import Swiper from "./Swiper";
import {
    getType,
    doesInclude,
    startWith,
    camelCase,
    convertFromString
} from "../../../../../GesagtGetan.Basic/Resources/Private/Assets/Helper";
import { mergeSettings } from "./Functions";
import type from "./Type";

export default function() {
    let swipers = document.querySelectorAll(".swiper-container");
    for (let i = 0; i < swipers.length; i++) {
        let slider = swipers[i];
        let wrapper = slider.querySelector(".swiper-wrapper");
        let nummberOfSlides = wrapper ? wrapper.childElementCount : false;
        if (nummberOfSlides) {
            let settings = {
                initialized: false
            };

            // Get the settings from CSS class
            let classList = slider.classList;
            for (let i = 0; i < classList.length; i++) {
                let className = classList[i];
                if (
                    doesInclude(className, "--") &&
                    startWith(className, "swiper-")
                ) {
                    let split = className.replace("swiper-", "").split("--");
                    let key = camelCase(split.shift());
                    settings[key] = convertFromString(split[0]);
                }
            }

            // Is the slider already initialized?
            if (settings.initialized) {
                // Get parameter from existing slider
                let params = slider.swiper.originalParams;
                // Destroy existing slider
                slider.swiper.destroy();
                // Re-build slider
                new Swiper(slider, params);
            } else {
                if (
                    settings.type &&
                    getType(type[settings.type]) === "function"
                ) {
                    type[settings.type](slider, settings, nummberOfSlides);
                } else {
                    settings = mergeSettings({
                        settings: settings,
                        nummberOfSlides
                    });
                    new Swiper(slider, settings);
                }
            }
        }
    }
}
